import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'Division Immobilière', path: '/division-immobiliere' },
    { name: 'Nos Biens', path: '/nos-biens' },
    { name: 'Nos Outils', path: '/nos-outils' },
    { name: 'Blog', path: '/blog' },
    { name: 'À Propos', path: '/qui-sommes-nous' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white z-50 header-shadow" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_beeb63f4-f271-4462-96ad-3cfca96ff85b/artifacts/c5rpsa8q_division%20immobiliere.jpeg" 
              alt="G Division" 
              className="h-20 sm:h-20 md:h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex items-center gap-5" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-[11px] font-semibold uppercase tracking-wide transition-colors whitespace-nowrap ${
                  isActive(link.path) 
                    ? 'text-[#c9a227]' 
                    : 'text-[#1e3a5f] hover:text-[#c9a227]'
                }`}
                data-testid={`nav-link-${link.path.replace('/', '') || 'home'}`}
              >
                {link.name}
                {isActive(link.path) && (
                  <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#c9a227]"></span>
                )}
              </Link>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:block">
            <Link to="/contact">
              <Button 
                className="bg-[#1e3a5f] text-white hover:bg-[#162a45] rounded-none px-6 py-2 uppercase tracking-wider text-sm font-semibold"
                data-testid="header-contact-btn"
              >
                Nous Contacter
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-[#1e3a5f]"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 mobile-menu-enter" data-testid="mobile-menu">
          <nav className="max-w-7xl mx-auto px-4 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 text-sm font-medium uppercase tracking-wider border-b border-gray-100 ${
                  isActive(link.path) ? 'text-[#c9a227]' : 'text-[#1e3a5f]'
                }`}
                onClick={() => setIsMenuOpen(false)}
                data-testid={`mobile-nav-link-${link.path.replace('/', '') || 'home'}`}
              >
                {link.name}
              </Link>
            ))}
            <Link 
              to="/contact" 
              className="block mt-4"
              onClick={() => setIsMenuOpen(false)}
            >
              <Button 
                className="w-full bg-[#1e3a5f] text-white hover:bg-[#162a45] rounded-none py-3 uppercase tracking-wider text-sm font-semibold"
                data-testid="mobile-contact-btn"
              >
                Nous Contacter
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
